import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {unlinkHubspotOrgId} from 'src/openapi/admin/apis/HubspotControllerApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useHubspotUnlinkConnection = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        unlinkHubspotOrgId({accountId}),
    ), [accountId, apiDispatch]);

    return useCommonEventHook({eventAction});
};
